import React, { FC } from 'react';
import { View } from 'react-native';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import NCFileBatchEvents from '@v2/pages/common/components/NCFileBatchEvents';
import { NcFileBatchEventType } from '@v2/pages/common/enums';
import { connect } from 'react-redux';
import { getNCFileById } from '@reducers/manufacture';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { productionBatchStatistics } from '@reducers/statistics';
import { updateHeaderConfig } from '@reducers/details';
import { useBatchDetails } from '@v2/pages/common/hooks/useBatchDetails';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { NCFileSearchItem } from '@interfaces/search';

interface BatchDetailsNCFileEventsSetupProps {
  ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem | null>;
}

const BatchDetailsNCFileEventsSetupComponent: FC<BatchDetailsNCFileEventsSetupProps> = ({
  clearTools,
  getNCFileById,
  getTools,
  productionBatchStatistics,
  updateHeaderConfig,
  ncFileData,
}) => {
  const title = useTitle();

  useBatchDetails({
    clearTools,
    getNCFileById,
    getTools,
    productionBatchStatistics,
    updateHeaderConfig,
  });

  const ncFileId = ncFileData.data?.ncFileId;

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <View style={{ flex: 1 }}>
        <NCFileBatchEvents {...{ eventType: NcFileBatchEventType.SETUP, ncFileId }} />
      </View>
    </DetailsPageWrapper>
  );
};

const BatchDetailsNCFileEventsSetup = connect(({ details: { ncFileData } }) => ({ ncFileData }), {
  clearTools,
  getNCFileById,
  getTools,
  productionBatchStatistics,
  updateHeaderConfig,
})(BatchDetailsNCFileEventsSetupComponent);

export { BatchDetailsNCFileEventsSetup };
